import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { connect } from 'react-redux';
import SubSectionWrapper from '../SubSectionWrapper';
import TabPanel from '../../../../components/TabPanel';
import BracketLibraries from '../BracketLibraries';
import CustomBracketSets from '../../../CustomBracketSets';
import { updateOrganizationAction } from '../../../../reducers/organizations';

const Brackets = ({ organization, isCustomBracketSetsEnabled, toggleEnableCustomBracketSets }) => {
  const [activeTab, setActiveTab] = React.useState(0);

  const otherActions = (
    <FormControlLabel
      control={
        <Switch checked={isCustomBracketSetsEnabled} onChange={toggleEnableCustomBracketSets} />
      }
      label="Enable"
    />
  );

  return (
    <Box width="100%">
      <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)}>
        <Tab label="Libraries" value={0} />
        <Tab label="Custom Sets" value={1} />
      </Tabs>
      <TabPanel value={activeTab} index={0}>
        <BracketLibraries organization={organization} />
      </TabPanel>
      <TabPanel value={activeTab} disableWrapper index={1}>
        <CustomBracketSets organization={organization} otherActions={otherActions} />
      </TabPanel>
    </Box>
  );
};

Brackets.propTypes = {};

export default connect(
  (state, { organization }) => ({
    isCustomBracketSetsEnabled: organization.enable_custom_bracket_sets
  }),
  (dispatch, { organization }) => {
    return {
      toggleEnableCustomBracketSets: () =>
        dispatch(
          updateOrganizationAction(
            { enable_custom_bracket_sets: !organization.enable_custom_bracket_sets },
            organization.id
          )
        )
    };
  }
)(props => {
  return (
    <SubSectionWrapper title="Brackets">
      <Brackets {...props} />
    </SubSectionWrapper>
  );
});
